import { Either } from 'monet';
import LeftResponse from '@/storage/LeftResponse';

/**
 * @description Запрос на заказ консультации.
 * @param {string} fullName ФИО.
 * @param {string} phone    Телефон.
 * @constructor
 */
export function OrderConsultationRequest(fullName, phone) {
  this.toQuery = () => ({
    full_name: fullName,
    phone,
  });
}

/**
 * @description Шлюз тарифов.
 * @param {Axios} axios
 */
export default function TariffGateway(axios) {
  /**
   * @description Заказать консультацию.
   * @param {OrderConsultationRequest} request
   * @returns {Promise<Either>}
   */
  this.orderConsultation = (request) => axios
    .post('/api/tariff/consultation-orders', request.toQuery())
    .then(
      async (response) => Either.right(response.data.message),
      async (error) => {
        if (error.isAxiosError && [400].includes(error.response.status)) {
          const { causes, title } = error.response.data;
          const leftResponse = new LeftResponse(causes, title);
          return Either.left(leftResponse);
        }
        throw error;
      },
    );
  /**
   * @description Получить данные по тарифу клиники
   * @returns {Promise<Either>}
   */
  this.getTariffInfo = () => axios
    .get('/api/tariff/info')
    .then(
      (response) => Either.Right(response.data),
      (error) => {
        if (error.isAxiosError && [400].includes(error.response.status)) {
          const { causes, title } = error.response.data;
          const leftResponse = new LeftResponse(causes, title);
          return Either.Left(leftResponse);
        }
        throw error;
      },
    );

  /**
   * @description Показать опции выставления счета клинике.
   * @returns {Promise<Either>}
   */
  this.viewBillingInvoiceOptions = () => axios
    .get('/api/billing-invoice-options')
    .then(
      (response) => Either.right(response.data.data),
      (error) => {
        if (error.isAxiosError && [400, 403].includes(error.response.status)) {
          return Either.left(error.response.data);
        }
        throw error;
      },
    );

  /**
   * @description Показать опции выставления счета клинике.
   * @returns {Promise<Either>}
   */
  this.createBillingInvoice = (request) => axios
    .post('/api/billing-invoices', request)
    .then(
      (response) => Either.right(response.data),
      (error) => {
        if (error.isAxiosError && [400, 403].includes(error.response.status)) {
          return Either.left(error.response.data);
        }
        throw error;
      },
    );

  /**
   * @description Скачать счет.
   * @returns {Promise<Either>}
   */
  this.downloadBillingInvoice = (invoiceId) => axios
    .get(`/api/billing-invoices/${invoiceId}/download`, { responseType: 'blob' })
    .then(
      (response) => Either.right(response.data),
      async (error) => {
        const getResponse = async () => {
          const json = await (error.response.data || '').text();
          const data = JSON.parse(json);
          return data;
        };
        if (error.isAxiosError && [403, 404].includes(error.response.status)) {
          const response = await getResponse();
          return Either.Left(response.title);
        }
        throw error;
      },
    );
}
